import React, { useState, useRef, useEffect } from "react";
import "../Home/Home.css";

const ITEMS_PER_VIEW = 3;

const TestimonialPreview = ({ previewService, setShowPreviewTestimonial }) => {

    const [videoIndex, setVideoIndex] = useState(0);
    const [reviewIndex, setReviewIndex] = useState(0);
    const [expandedReviews, setExpandedReviews] = useState({});
    const [overflowMap, setOverflowMap] = useState({});
    const reviewRefs = useRef({});

    const {
        heading,
        title,
        description,
        videoTestimonials = [],
        videoReviews = [],
    } = previewService;

    /* ---------------- VIDEO HANDLERS ---------------- */
    const handleNextVideo = () => {
        if (videoIndex + ITEMS_PER_VIEW < videoTestimonials.length) {
            setVideoIndex(videoIndex + ITEMS_PER_VIEW);
        }
    };

    const handlePrevVideo = () => {
        if (videoIndex - ITEMS_PER_VIEW >= 0) {
            setVideoIndex(videoIndex - ITEMS_PER_VIEW);
        }
    };

    const visibleVideos = videoTestimonials.slice(
        videoIndex,
        videoIndex + ITEMS_PER_VIEW
    );

    /* ---------------- REVIEW HANDLERS ---------------- */
    const handleNextReview = () => {
        if (reviewIndex + ITEMS_PER_VIEW < videoReviews.length) {
            setReviewIndex(reviewIndex + ITEMS_PER_VIEW);
        }
    };

    const handlePrevReview = () => {
        if (reviewIndex - ITEMS_PER_VIEW >= 0) {
            setReviewIndex(reviewIndex - ITEMS_PER_VIEW);
        }
    };

    const visibleReviews = videoReviews.slice(
        reviewIndex,
        reviewIndex + ITEMS_PER_VIEW
    );

    useEffect(() => {
        if (!visibleReviews.length) return;

        const newOverflowMap = {};

        visibleReviews.forEach((r) => {
            const el = reviewRefs.current[r.review_id];
            if (el) {
                newOverflowMap[r.review_id] =
                    el.scrollHeight > el.clientHeight;
            }
        });

        setOverflowMap(newOverflowMap);
    }, [visibleReviews]);

    const toggleReview = (id) => {
        setExpandedReviews((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    if (!previewService) return null;



    return (
        <div className="tp-overlay" onClick={() => setShowPreviewTestimonial(false)}>
            <div className="tp-modal" onClick={(e) => e.stopPropagation()}>

                <button className="tp-close" onClick={() => setShowPreviewTestimonial(false)}>
                    ✕
                </button>

                {/* HEADER */}
                <div className="tp-header">
                    <span className="tp-label">{heading}</span>
                    <h2>{title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>

                {/* ================= VIDEO CAROUSEL ================= */}
                <div className="tp-carousel">

                    <button
                        className="tp-arrow left"
                        onClick={handlePrevVideo}
                        disabled={videoIndex === 0}
                    >
                        ‹
                    </button>

                    <div className="tp-cards">
                        {visibleVideos.map((item) => (
                            <div className="tp-card" key={item.videotestimonial_id}>
                                <video controls>
                                    <source src={item.videos?.trim()} type="video/mp4" />
                                </video>

                                <div className="tp-card-body">
                                    <h4>{item.name}</h4>
                                    <div className="tp-card-body-quote">
                                        <span>{item.professional}</span>
                                        <div className="tp-quote">❝</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        className="tp-arrow right"
                        onClick={handleNextVideo}
                        disabled={videoIndex + ITEMS_PER_VIEW >= videoTestimonials.length}
                    >
                        ›
                    </button>

                </div>

                {/* ================= REVIEW CAROUSEL ================= */}
                {visibleReviews.length > 0 && (
                    <div className="tp-carousel">

                        <button
                            className="tp-arrow left"
                            onClick={handlePrevReview}
                            disabled={reviewIndex === 0}
                        >
                            ‹
                        </button>

                        <div className="tp-reviews">
                            {visibleReviews.map((r) => (
                                <div className="tp-review-card" key={r.review_id}>
                                    <div className="tp-review-header">
                                        <img
                                            src={r.imageupload || "/default-user.png"}
                                            alt={r.name}
                                        />

                                        <div>
                                            <h4>{r.name}</h4>
                                            <span>{r.professional}</span>
                                        </div>

                                        <div className="tp-rating">
                                            {"★".repeat(r.rating)}
                                            {"☆".repeat(5 - r.rating)}
                                        </div>
                                    </div>
                                    <hr class="expressdividers col-12 mt-4"></hr>
                                    <p
                                        ref={(el) => (reviewRefs.current[r.review_id] = el)}
                                        className={`tp-review-text ${expandedReviews[r.review_id] ? "" : "clamp"}`}
                                        dangerouslySetInnerHTML={{ __html: r.description }}
                                    />

                                    {/* SHOW ONLY IF OVERFLOW */}
                                    {(overflowMap[r.review_id] || expandedReviews[r.review_id]) && (
                                        <button
                                            className="tp-readmore"
                                            onClick={() => toggleReview(r.review_id)}
                                        >
                                            {expandedReviews[r.review_id] ? "Hide" : "Read more"}
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>

                        <button
                            className="tp-arrow right"
                            onClick={handleNextReview}
                            disabled={reviewIndex + ITEMS_PER_VIEW >= videoReviews.length}
                        >
                            ›
                        </button>

                    </div>
                )}

            </div>
        </div>
    );
};

export default TestimonialPreview;
